import { gql } from '@apollo/client'

export const GET_EOD_SESSION = gql`
  query GetEodSession($date: String!) {
    eodSession(date: $date) {
      id
      date
      status
      general_notes
      notes_for_tomorrow
      incidents {
        id
        eod_session_id
        description
        severity
        created_by
        created_at
      }
      created_by
      submitted_by
      submitted_at
      last_modified_by
      created_at
      updated_at
    }
  }
`

export const GET_TRACKED_RECIPES = gql`
  query TrackedRecipes {
    trackedRecipes {
      id
      name
      unit
      output_quantity
    }
  }
`

// Production-only ledger query — no financial fields, safe for all roles including shift lead
export const GET_DAILY_LEDGER_RECIPES = gql`
  query GetDailyLedgerRecipes($date: String!) {
    dailyLedgerSummary(date: $date) {
      date
      recipes {
        raw_material_id
        raw_material_name
        unit
        cooked_quantity
        reheated_quantity
        stored_quantity
        sold_quantity
        sold_portions
        sold_portions_breakdown {
          product_name
          variant_name
          portions
        }
        sold_portions_by_options {
          option_item_ids
          portions
          option_labels
        }
        expired_quantity
        wasted_quantity
        consumed_staff_quantity
        variance_quantity
        current_stock
      }
    }
  }
`

// Financial summary query — requires order.financial.view + costing.margin.view; only fetched for privileged roles
export const GET_DAILY_LEDGER_FINANCIAL = gql`
  query GetDailyLedgerFinancial($date: String!) {
    dailyLedgerSummary(date: $date) {
      date
      revenue_cents
      cogs_cents
      gross_margin_cents
      gross_margin_percentage
      delivery_fee_ex_vat_cents
      order_count
      lines_without_cogs_count
      total_production_cost_cents
    }
  }
`
